module.exports = __webpack_public_path__ + "static/media/documentation.de55432c.svg";